import { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { getCompanyAddress } from '@helpers/companies';
import { toSystemFields, useContactFieldsValues } from '@features/ContactFieldsSettings';

const Negative = ({ locationSurveyId, location, wording, languages }) => {
    const iframeRef = useRef(null);
    const { watch, control } = useFormContext();
    const customFields = useWatch({ control, name: 'customFields' });
    const contactFields = useContactFieldsValues();
    const contactFormPlacement = watch('contactFormPlacement');
    const satisfactionSurveyEnabled = watch('satisfactionSurveyEnabled');
    const satisfactionSurveyThreshold = Number(watch('satisfactionSurveyThreshold'));

    useEffect(() => {
        const controller = new AbortController();
        const data = {
            locationName: location.locationName,
            businessAddress: getCompanyAddress(location.addressLine1, location.city),
            hasBusinessAddress: location.hasBusinessAddress,
            customFields,
            contactFormPlacement,
            satisfactionSurveyEnabled,
            satisfactionSurveyThreshold,
            languages,
            ...wording,
            systemFields: toSystemFields(contactFields),
        };
        iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-negative', data }, '*');
        const sendUpdatedData = event => {
            if (event.origin === import.meta.env.REACT_APP_SURVEY_DOMAIN) {
                const message = event.data;
                if (message.type === 'pl-preview-iframe-loaded') {
                    iframeRef.current?.contentWindow?.postMessage({ type: 'pl-preview-survey-negative', data }, '*');
                }
            }
        };
        window.addEventListener('message', sendUpdatedData, { signal: controller.signal });
        return () => controller.abort();
    }, [
        location,
        customFields,
        ...Object.values(contactFields),
        contactFormPlacement,
        satisfactionSurveyEnabled,
        satisfactionSurveyThreshold,
        languages,
        wording,
    ]);

    return (
        <iframe
            ref={iframeRef}
            allow="autoplay"
            width="100%"
            height="100%"
            src={`${import.meta.env.REACT_APP_SURVEY_DOMAIN}/preview/negative/${locationSurveyId}`}
            frameBorder="0"
        ></iframe>
    );
};

export default Negative;
